<template>
    <div class="tab-mission-wrap section-space--mt_60">
        <div class="row align-items-center">
            <div class="col-lg-7">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/tokenizer_how_to.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-5">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("tokn.how_it_works") }}</h4>
                    <p class="dec mt-10 section-space--mb_40" v-html="$t('tokn.how_text')"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentTwo'
}
</script>
